import { Befehlsnachricht } from '@/models/Befehlsnachricht'
import { getBefehlsnachrichtAsPdf } from '@/apis/Befehlsnachricht'
import { useCaptureException } from '@repo/ui'
import { Abruftoken } from '@/models/Abruftoken'
import { useMutation } from '@tanstack/react-query'

// Helper function outside of hook to avoid re-creation on every render
const triggerBrowserDownload = (blob: Blob, filename: string) => {
  const downloadUrl = globalThis.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = downloadUrl
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  globalThis.URL.revokeObjectURL(downloadUrl)
}

/**
 * Hook for downloading Befehlsnachricht as PDF
 * @param bfnId - Optional BFN ID for mutation key (used for tracking state across components)
 * @returns React Query mutation object
 */
export default function useBefehlsnachrichtPdfDownload(
  bfnId?: Befehlsnachricht['id']
) {
  const { captureException } = useCaptureException()

  return useMutation({
    mutationKey: ['befehlsnachricht-pdf-download', bfnId],
    mutationFn: ({
      abruftoken,
      manuellWiderrufenAt
    }: {
      abruftoken: Abruftoken
      manuellWiderrufenAt?: Date
    }) => getBefehlsnachrichtAsPdf(abruftoken, manuellWiderrufenAt),
    onSuccess: ({ blob, filename }) => {
      triggerBrowserDownload(blob, filename)
    },
    onError: (error) => {
      captureException(error, 'download-befehlsnachricht-pdf', {
        bfnId
      })
    },
    // Automatically clean up mutation when no component is observing it
    gcTime: 0
  })
}
